import { SourcingChannelStatus, SourcingService } from 'api-clients/monolith';

import { DateRangeFilter } from '@/contexts/table-context';

import { campaignsDateParams } from './campaigns-date-params';

type CampaignsMetricsQueryParams = {
  search?: string;
  channelIds?: string[];
  statuses?: string[];
  positionIds?: string[];
  locationIds?: string[];
  brandIds?: string[];
  dateRange?: DateRangeFilter;
  /** Whether the account counts metrics in calendar days at each opening. */
  localDays?: boolean;
  /** Count a custom range's applicants hired through today. */
  hiresToDate?: boolean;
};

/**
 * The openings[] filter is intentionally omitted — no UI in the Filters bar
 * surfaces it today.
 */
export function getCampaignsMetrics(params: CampaignsMetricsQueryParams = {}) {
  const dates = campaignsDateParams(
    params.dateRange,
    params.localDays ?? false,
  );
  return SourcingService.getInternalApiSourcingCampaignsMetrics(
    dates.preset,
    dates.startDate,
    dates.endDate,
    params.channelIds,
    params.statuses as SourcingChannelStatus[] | undefined,
    params.positionIds,
    params.locationIds,
    params.brandIds,
    undefined,
    params.search,
    params.hiresToDate || undefined,
  );
}
